import React, { useRef } from "react";
import { message } from "antd";
import { IYhFormRef, FormItemTypeEnum, IYhForm, ISelectOption } from "@/components/YhFormBox/Types";
import { getFormValidatorErrText } from "@/utils/utils";
import { YHDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { IKerwordsTypeInsert } from "../keyWordsService";
import { useKeyWordsModel } from "../keyWordsModel";


export function KeyWordsTypeDrawer() {
	const { keyWordsTypeDrawer: { visible, mode }, selectedRowKeysType, setKeyWordsTypeDrawer, insertKeyWordsType, updataKeyWordsType } = useKeyWordsModel();
	const formRef = useRef<IYhFormRef>();

	const onCancel = () => {
		setKeyWordsTypeDrawer({ visible: false, mode: "add" });
	}

	//表单提交
	const onSubmit = async () => {
		formRef.current?.validateFields().then((val: IKerwordsTypeInsert) => {
			if (mode === "add") {
				insertKeyWordsType({
					...val,
					status: "1"
				})
			} else {
				let { id, status } = selectedRowKeysType[0];
				updataKeyWordsType({
					id, status,
					name: val.name
				})
			}
		}).catch(err => {
			message.warning(getFormValidatorErrText(err));
		})
	}



	const formConfig: IYhForm = {
		formRef,
		labelCol: { span: 6 },
		formValues: mode === "edit" ? selectedRowKeysType?.[0] ?? {} : {},
		items: [
			{
				type: FormItemTypeEnum.Input,
				fieldLabel: "新增分类",
				fieldName: "name",
				span: 24,
				rules: [{ required: true, message: "请输入分类名称" }]
			}
		]
	};
	return (
		<YHDrawer
			{...{
				title: `分类${mode === "edit" ? "编辑" : "新增"}`,
				visible,
				onCancel,
				okText: "保存",
				onOk: onSubmit
			}}
		>
			<YhForm {...formConfig} />
		</YHDrawer>
	)
}
